module.exports = __webpack_public_path__ + "static/img/DIDTrackLogo.039983e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DIDTrackLogo.png
// module id = HXri
// module chunks = 1